import styles from './AdvtCenter.module.css';
import { motion } from 'framer-motion';

export const AdvtCenter = ({ advtInfo, title1FontSize }) => {
  const { qrCode1, qrCode2, label, paddingQR } = advtInfo;

  let heightLabel = Math.round(Number(title1FontSize) * 9.6);
  return (
    <div className={styles.wrapperAdvtCenter}>
      <motion.div
        initial={{ height: 0, y: heightLabel }}
        animate={{ height: heightLabel, y: 0 }}
        transition={{ duration: 1, delay: 0.2 }}
        className={styles.label}
        style={{
          fontSize: `${title1FontSize}rem`,
          lineHeight: `${title1FontSize}rem`,
        }}>
        {label}
      </motion.div>
      <div className={styles.qrWrapper}>
        {qrCode1 && (
          <motion.div
            className={styles.qrItem}
            key="qr1"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 1, delay: 0.2 }}
            style={{ padding: `${paddingQR * 1.5}rem` }}>
            <img src={qrCode1} alt="" />
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            className={styles.qrItem}
            key="qr2"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 1, delay: 0.6 }}
            style={{ padding: `${paddingQR * 1.5}rem` }}>
            <img src={qrCode2} alt="" />
          </motion.div>
        )}
      </div>
    </div>
  );
};
